export default {
  hsk_left_time: "残り時間",
  hsk_submit_paper: "解答を提出する",
  hsk_not_finished: 'Not finished',
  hsk_not_start: 'Not started',
  hsk_finished: "完了済",
  hsk_if_test: "解答が完了していない試験があります。試験を継続しますか？",
  hsk_start_again: "最初からやり直す",
  hsk_go_on: "試験を続ける",
  hsk_if_save: "本当に受験をやめますか？退出後も解答は保存され、次回は現在の問題から継続できます。",
  hsk_login_filed: 'Your login information has expired, and we will not keep your answer record.',
  hsk_report: "解答結果",
  hsk_point: "点",
  hsk_qualified_point: "合格点：{points}",
  hsk_part1: "第{part}部分",
  hsk_accuracy1: "正確度",
  hsk_test_again: "もう一度受験する",
  hsk_example: "例",
  hsk_example_eg: "例",
  hsk_answer_analysis: '正しい答え:',
  hsk_your_answer: 'あなたの答え:',
  hsk_audio_text: 'Audio:',
  hsk_correct_answer: '正しい答え:',
  hsk_listen_name: "聞き取り",
  hskk_listen_name: 'スピーカーとマイクのテスト',
  hsk_read_name: "読解",
  hsk_write_name: "作文",
  hsk_reference_answer: "解答例：",
  hsk_reference_answer_hskk: '質問オーディオコンテンツ:',
  hsk_submit_msg: "本当に提出しますか？",
  hsk_homework_no_answer: "未解答",
  hsk_practice_sava: 'Quit? Your answers will not be saved.',
  hsk_practice_go: 'Try it',
  hsk_practice_part: 'Section',
  hsk_practice_operate: 'Actions',
  hsk_practice_check: "見る",
  hsk_practice_num1: "正解",
  hsk_practice_num2: "全{totalNum}問中",
  hsk_preview_listen_msg: "今から試験の説明を開始します。説明中は、聞き取りの試験問題をプレビューできます。",
  hsk_preview_listen_prompt: "今から試験の説明を開始します。説明中は、聞き取りの試験問題をプレビューできます。解答データの消失防止のため、試験中はページを更新したり、閉じたりしないでください。",
  hsk_enter_next_segment_msg: "次のセクションに進みますか？",
  hsk_enter_next_segment_preview: "プレビューを終了しますか？プレビュー終了後は、すぐに聞き取り問題が始まります。",
  hsk_enter_next_segment_listen_tip: "聞き取り問題{count}問が未解答です。",
  hsk_enter_next_segment_listen: "聞き取りのセクションを終了して提出しますか？",
  hsk_enter_next_segment_listen_review_start: "今から{count}分間、聞き取り問題の解答状況を振り返りできます。",
  hsk_enter_next_segment_listen_review: "聞き取り問題の振り返りを終了しますか？終了後は、すぐに読解問題が始まります。",
  hsk_enter_next_segment_read_tip: "読解問題{count}問が未解答です。",
  hsk_enter_next_segment_read: "読解のセクションを終了して提出しますか？提出後は、解答内容を変更できません。",
  hsk_enter_next_segment_write_tip: "作文問題{count}問が未解答です。",
  hsk_enter_next_segment_write: "本当に試験を提出しますか？",
  hsk_end_preview: "プレビューを終了する",
  hsk_submit_listen: "聞き取りを提出する",
  hsk_end_review: "振り返りを終了する",
  hsk_start_exam: "試験を始める",
  hsk_start_exam_new: '始める',
  hsk_link_test: "過去問を解く",
  hsk_link_tips: "実際に出題された過去問を解いて、公式証書を手に入れよう",
  hsk_buy: "購入",
  hsk_test_ready: "準備",
  hsk_test_ready_tips: "この試験問題には、聞き取り問題が含まれます。あらかじめ音声設定を調整してください。",
  hsk_test_content: "試験内容",
  hsk_test_num: "問題数",
  hsk_total_num: "全問題数",
  hsk_test_time: "試験時間",
  hsk_time_total: "合計",
  hsk_test_minute: "分間",
  hsk_about: "約",
  hsk_abbreviation: "開始",
  hsk_determine_ans: "本当に解答を始めますか？",
  hsk_determine_ans_tips: "一度解答を開始すると、原文を再度見ることはできません",
  no_data: "データ無し",
  hsk_question_number: "問題数",
  hsk_test_rate: "試験の比率",
  hsk_right_rate: "正解率",
  hsk_operation: "操作",
  hsk_skip: "スキップ",
  hsk_spend: "消費",
  hsk_cost: "費用",
  hsk_credit: "残高",
  hsk_pay_successfully: "支払成功",
  hsk_select_amount: "チャージ金額を選択",
  button_common_ok: "確定",
  button_common_cancel: "キャンセル",
  change_lang_ok: "確定",
  change_lang_cancel: "キャンセル",
  hint_player_loader_error: "音声の再生に失敗しました。",
  hint_common_wait_loading: "ロード中",
  button_common_hand_in: "提出",
  test_total_question: "全{count}問",
  test_release: "公開する",
  test_off_shelf: "非公開にする",
  test_enable: "受験可能にする",
  test_record: "模擬試験の記録",
  test_finish_time: "完了時間",
  test_paper: "試験問題",
  test_confirm_use: "模擬試験を公開する",
  test_confirm_off_shelf: "模擬試験を非公開にする",
  test_has_on_shelf: "公開済",
  test_un_release: "未公開",
  test_un_enable: "受験不可",
  test_max_score: "最高点",
  test_average_score: "平均点",
  test_min_score: "最低点",
  test_all: "全て",
  test_has_practiced: "結果を見る",
  test_paper_office: "試験問題は非公開になっています。",
  test_complete_introduce: "詳細説明",
  test_course_link: "公式カリキュラム",
  test_about_down_load: "ダウンロード",
  test_pay: "支払",
  mark_answer_user: "解答者",
  mark_answer_time: "提出時間",
  mark_correct_time: "添削時間",
  mark_correct_status: "添削状況",
  mark_correct_user: "添削者",
  mark_correct_option: "操作",
  mark_correct_ing: "添削中",
  mark_un_correct: "未添削",
  mark_has_correct: "添削済",
  mark_report_tips: "注：作文部分は合計点に含まれていません。第{markNumberDesc}問は専門の添削員が48時間以内に添削し、添削結果をこの画面とメールでお知らせします。",
  mark_report_tips_hskk: 'Note: The test questions will be graded by professional evaluators within 48 hours. After the grading is completed, the general branch will update them synchronously. We will notify you by email at that time',
  mark_submit_btn: "添削内容を送信する",
  mark_submit_tips: "本当に送信しますか？",
  mark_back: "戻る",
  mark_correct_tips: "この模擬試験は添削中です。重複しての添削はできません。",
  mark_correct_person: "手動で添削する",
  search_user_message: "ユーザー検索",
  mark_current_user: "現在のユーザー",
  mark_correct_paper: "添削",
  mark_all_status: "全てのステータス",
  mark_all_level: "全ての級",
  mark_overtime: "期限超過",
  mark_answer: "解答",
  home_test_registration: "受験申込",
  home_word_outline: "語彙チェック",
  home_online_practice: "無料サンプル問題",
  home_test: "実戦模擬試験",
  home_page: "トップページ",
  common_text_control_speed: "再生速度",
  button_common_playback: "録音を再生する",
  common_text_file_error: "ファイルの形式が間違っているか、サイズが大きすぎます。",
  common_text_server_error: "再試行",
  common_text_none_network: "接続が不安定です。",
  button_common_start_over: "リトライ",
  evaluating_tips_common: "朗読の録音とテキストの内容が大きく違います。もう一度録音してください。",
  evaluate_common_total_score: "得点",
  evaluate_common_training_remain: "残り：",
  evaluate_common_training_readyRcord: "録音準備",
  evaluate_common_training_atleast: "録音時間は1秒より長い必要があります。",
  evaluate_common_training_atleast2: "録音時間は2秒より長い必要があります。",
  evaluate_common_training_evaluting: "採点中",
  evaluating_tips_additionalAndBack: "朗読中に同じ部分の繰り返しがありました。総得点に影響します。",
  textbook_chioce_word_text_correct_tip: "正解です。素晴らしい！",
  textbook_chioce_word_text_error_tip: "不正解です。頑張って！",
  textbook_reading_comprehension_stem: "読解",
  spc_back_tips: "本当に練習をやめますか？現在の解答は保持されません。",
  spc_level_text: "レベルチェックテスト",
  spc_capability_assessment: "能力評価",
  spc_pick_level: "級の選択",
  spc_listen: "聞く",
  spc_speak: "話す（スピーキング）",
  spc_read: "読む",
  spc_write: "書く",
  spc_translation: "訳す",
  spc_result_tips: "レベルチェックテストの結果、あなたの中国語能力はHSK{level}級に相当します。",
  spc_recommend_test: '推荐备考 HSK {level} 级',
  spc_recommend_test1: "<strong>HSK{level}</strong>級に向けて準備することをお勧めします。",
  spc_again_test: "再テスト",
  spc_where_tips: "自分のレベルが不明？",
  spc_immediate_test: "テストを受けてみる",
  spc_test_content: "試験内容",
  spc_test_content_desc: "「聞く・話す・読む（朗読）・書く（入力または選択）・訳す」の五要素で学習者の能力を判断します。級ごとに問題は異なります。",
  spc_test_timer: "テスト時間",
  spc_test_timer_desc: "およそ15分前後かかります。一般的に、級が高いほど時間も長くなります。",
  spc_test_result: "テスト結果",
  spc_test_result_desc: "目標の級や、特に強化が必要な技能を決めるのに役立ちます。",
  vocab_level_word: "{level}級の語彙リスト",
  vocab_total_item: "全{total}個",
  vocab_search: "漢字/拼音/意味で検索",
  vocab_all_marked: "全て",
  vocab_already_marked: "ブックマーク済",
  vocab_unmarked: "未ブックマーク",
  vocabulary: "語句",
  vocab_pinyin: "拼音",
  vocab_translate: "意味",
  vocab_mark: "ブックマーク",
  delete_confirmation: "本当に語彙を削除しますか？",
  cancel: "キャンセル",
  del: "削除",
  edit_vocab: "語彙を編集",
  save: "保存",
  add_vocab: "語彙を追加",
  hanzi: "漢字",
  num_bihua: "画数",
  write_demo: "書き方",
  vocab_side: "部首",
  level: "級",
  see_more: "もっと見る >",
  same_read_word: "同音字",
  samilar_read_word: "近音字",
  add_mark: "ブックマーク",
  word_team: "熟語",
  instance: "例文",
  include_num_char: "漢字を{total}文字含む",
  length_diff: "拼音と漢字の長さが一致していません。",
  add_word_success: "語彙を追加しました。",
  add_word_fail: "語彙の追加に失敗しました。",
  edit_word_success: "語彙を編集しました。",
  edit_word_fail: "語彙の編集に失敗しました。",
  del_success: "削除しました。",
  del_fail: "削除に失敗しました。",
  mark_free: "「覚えた」など、自由にメモできます。",
  write_word_sentence: "上記の単語を使って、文を作ってください…",
  write_word_artical: "上記のキーワードを使って、短いエッセイを書いてください…",
  write_img_artical: "上記の図に基づいて、短いエッセイを書いてください…",
  write_artical_title: "タイトルを入力…",
  write_artical_content: "本文を入力…",
  my_wallet: "購入履歴",
  learn_history: "学習の記録",
  manage: "アカウント管理",
  birthday: "生年月日",
  email: "メールアドレス",
  change_pw: "パスワードを変更する",
  edit_info: "プロフィールを編集",
  lastName: "姓",
  firstName: "名",
  gender: "性別",
  female: "女",
  male: "男",
  non_disclosure: "その他/秘密",
  change_avatar: "アイコンを変更",
  preview_avatar: "プレビュー",
  upload_image: "画像をアップロード",
  change_image: "画像を変更",
  enter_old_pw: "元のパスワード",
  enter_new_pw: "新しいパスワード",
  enter_new_pw_again: "新しいパスワードの再入力",
  forget_pw: "パスワードをお忘れですか？",
  recharge: "チャージ",
  left_balance: "利用可能な残高",
  consume_log: "試験問題",
  recharge_log: "購入履歴",
  consume_time: "日時",
  consume_source: "購入内容",
  consume_money: "金額",
  total_item_log: "計{total}件の履歴",
  recharge_time: "日時",
  recharge_num: "数量",
  recharge_money: "金額",
  recharge_method: "お支払い方法",
  learn_content: "学習内容",
  total_score: "合計点",
  view_result: "成績を見る",
  management: "アカウント管理",
  give_history: "ギフト",
  total_recharge: "チャージ",
  last_login: "Last log in",
  give: "Give papers",
  gifted: "ギフト",
  give_time: "日時",
  give_to_person: "Given to",
  opera_person: "操作者",
  give_to: "Give papers to",
  old_password_empty: "旧パスワードは空欄にできません。",
  diff_password: "パスワードが一致しません。",
  change_pw_success: "パスワードを変更しました。",
  change_pw_fail: "パスワードの変更に失敗しました。",
  change_info_success: "情報を更新しました。",
  change_info_fail: "情報の更新に失敗しました。",
  statistics_center: "統計センター",
  select_recharge_mount: "チャージ金額を選択",
  waiting_pay: "支払保留中…",
  has_no_resolve_credit: "お支払いに失敗しました。もう一度お試しください。",
  complete_pay: "お支払いが完了しました。",
  pay_fail: "お支払いに失敗しました。",
  give_success: "クレジットを付与しました。",
  give_fail: "クレジットの付与に失敗しました。",
  change_avatar_success: "アイコンを変更しました。",
  change_avatar_fail: "アイコンの変更に失敗しました。",
  enter_family_name: "姓を入力",
  enter_given_name: "名を入力",
  log_in: "Log in",
  log_in_error: "Login failed",
  email_address: "メールアドレス",
  invalid_email_address: "無効なメールアドレスです。",
  password: "Password",
  password_tip: "パスワードは6~20文字である必要があります。",
  invalid_password: "パスワードの形式が間違っています。",
  have_account: "{text}のアカウントが既に存在します。",
  sign_up: "Sign up",
  sign_up_error: "Registration failed",
  forget_pw_success: "パスワード再設定メールを送信しました。",
  forget_pw_error: "パスワード再設定メールの送信に失敗しました。",
  loading: "ロード中",
  account_block: "このアカウントはご利用になれません。",
  account_block_tip: "詳しくはご所属の学校の管理員にご連絡ください。",
  resend_email: "メールを再送する",
  resend_email_success: "メールを再送しました。",
  resend_email_error: "メールの再送に失敗しました。",
  i_am: "私は",
  choose_role: "あなたに最もよく当てはまるのは",
  choose_role_error: "誤った役割が選択されました。",
  continue: "次へ",
  learner: "学生",
  learner_description: "中国語を学んでいます",
  teacher: "教師",
  teacher_description: "中国語を教えています",
  setup_account_error: "アカウントのセットアップに失敗しました。",
  tos_link: "利用規約",
  privacy_link: "プライバシーポリシー",
  email_verified: "メールアドレスの認証が完了しました！",
  email_verified_tip: "メールアドレスを認証いただき、ありがとうございます。",
  email_verified_error: "アカウントを認証できませんでした。",
  something_wrong: "エラー",
  retry: "リトライ",
  guardian_consent_error: "エラーが発生しました。",
  about_us: "私たちについて",
  about_us_new: '私たちについて',
  feedback: "お問い合わせ",
  download: "ダウンロード",
  submit: "送信",
  feedback_success: "送信成功",
  feedback_error: "送信失敗",
  logout: "ログアウト",
  my_account: "アカウント情報",
  login_signup: "ログイン / 新規登録",
  please_enter_content: "お問い合わせ内容（必須）",
  describe_detail: "エラーをご報告の場合は、可能な限り詳細にお教えください",
  upload_picture: "jpg/png画像のアップロード（任意。最大9枚、各2MBまでアップロード可能）",
  file_error: "ファイルの形式が間違っているか、サイズが大きすぎます。",
  file_num_limit: "ファイルのアップロード上限：{maxFiles}件",
  sure_change_lang: "言語を切り替えますか？",
  privacy_policy_text1: "HSK Mock.com——漢考国際公認の唯一の模擬試験プラットフォーム",
  privacy_policy_text2: "HSK Mockは、Wo Huiと漢考国際がHSK・YCTの試験問題データベースを基に共同開発・運営しているサービスです。実際に出題された問題を使った模擬試験での学習をサービスを提供し、中国語試験を受験する中国語学習者と伴走します。",
  privacy_policy_text3: "Wo Hui Mandarinは漢考国際の公式協力パートナーです。",
  privacy_policy_text4: "漢考国際科技（北京）有限公司は、国際中国語教育・試験の専門機関です。世界中の国と地域に向けて国際中国語教育および試験の研究・設計・技術開発・試験実施・マーケティング等のサービスを提供し、全世界の中国語学習者と中国語教育機構のニーズに最大限応えています。",
  privacy_policy_text5: "Wo HuiはEiM国際教育グループが2018年にシンガポールで設立した、全世界の中国語学習者に向けて中国語学習の技術的サポート・プラットフォームサービスを提供する独立企業です。学生ひとりひとりに合った多様なカリキュラムや、教師の皆様のための豊富な教育リソース・実用的な教育ツールを提供しています。科学技術による教育サポートにより、教師の皆様の負担なく学生ひとりひとりに合った学習を可能にしています。",
  privacy_policy_text6: "漢考国際とWo Huiは良好な協力関係のもと、中国語学習の普及と発展に共同で取り組んでいます。より正確に学生のレベルを判断し、パーソナライズされた学習や、実際に出題された問題に基づく模擬試験によって、全方位的に中国語学習者のニーズを満たすべく、戦略的な協力を深化させています。",
  level_test: "レベルチェックテスト",
  level_test_example: "もし自分のレベルが不明な場合は、無料のレベルチェックテストを受験することで、どのレベルの学習目標を立てるべきかがわかります。",
  download_app_mobile: "より良いユーザー体験のため、デスクトップ版でhskmock.comにアクセスするか、アプリをダウンロードしてHSK Mockをご利用ください。",
  common_video_failed: "音声のロードに失敗しました。",
  member_error: "リソースに異常が発生しました！",
  agree_policy: 'I agree to <u class="strong"><a href="{url}" target="_blank">Terms of Services</a></u> and <u class="strong"><a href="{url}" target="_blank">Privacy Policy</a></u>',
  please_check: "Please read and agree to Terms of Services and Privacy Policy",
  media_devices_unsupported_browserLabel: "Google Chromeをデフォルトのブラウザとして使用することを推奨します。Windows 10での設定方法：設定-アプリ-既定のアプリ-Web ブラウザー-Google Chromeを選択",
  media_devices_help_title: "マイクを起動しますか？",
  media_devices_help_content: "音声を録音するためには、マイクの使用を許可する必要があります。",
  batch_exist_user: "{number} registered",
  batch_and: "and",
  batch_un_exist_user: "{number} unregistered",
  batch_from: "から",
  batch_notes: "Notes",
  batch_something: "Write something",
  batch_people_number: "Given to",
  batch_use_number2: "Spent",
  batch_operation_status: "Status",
  batch_ing_status: "In progress",
  batch_success: "Succeeded",
  batch_failed: "Failed",
  batch_select: "選択してください",
  common_to: "まで",
  common_start_time: "開始日",
  common_end_time: "終了日",
  batch_search_tips: "Separate multiple email addresses with a comma, up to 50 emails at a time.",
  common_un_exist: "Unregistered",
  common_invalid: "Invalid",
  batch_all_give: "Give papers to all",
  batch_single_people: "Individuals",
  batch_all: "Batches",
  batch_name: "名称",
  batch_added_credits: "Added credits",
  batch_spent_credits: "Spent credits",
  batch_account_status: "Account status",
  batch_Added_total: "合計",
  batch_spent_total: "合計",
  batch_Remaining: "Remaining",
  batch_Recipients: "Recipients",
  batch_Active: "Active",
  batch_search: "Search",

  certificate_details: "証書の詳細",
  get_official_mock_certificate: "模擬試験の公式証書を入手",
  certificate_tips: "プロフィールから詳細情報を取得しました。お間違いがないかご確認ください。",

  country: "国籍", // Nationality
  select_country: "国籍を選択してください",
  email_to: "証書を下記のメールアドレスにお送りしました：",

  polyphonic: "多音字",
  click_tips: "問題番号をクリックして答案を見る",
  download_tips: "合格した模擬試験の証書をダウンロードできます。",

  cancel_delete_account: "アカウントを削除する",
  cancel_confirm: "確認", // Confirm

  user_apply_delete_account_title: "アカウントの削除を申請",
  user_apply_delete_account_confirm_tip: "ログイン情報を確認",
  user_apply_delete_account_alwaysTip: "あなたのHSK Mockアカウントおよび関連する個人データを永久に削除しようとしています。",
  user_apply_delete_account_confirm_tip2: "削除申請を送信する前に、身分情報を確認してください。",
  user_apply_delete_account_desc: "あなたのアカウント{email}は、<a href=\"{wohuiLink}\" target=\"_blank\">Wo Hui Mandarin</a> と<a href=\"{mockLink}\" target=\"_blank\">HSK Mock</a>へのログインに使用されています。",
  user_apply_delete_account_desc2: "削除後は、このアカウントでの上記サービスへのログインができなくなります。",

  user_apply_delete_account_wohui_title: "Wo Huiのサブスクリプションを解除する",
  user_apply_delete_account_hsk_title: "HSK Mockの残高",

  user_apply_delete_account_next_tip: "\"次へ\" ボタンを一度だけクリックすると、上記の内容に同意したことになります。",
  user_apply_delete_account_next_title: "次へ",
  user_apply_delete_account_confirm_tip11: "アカウントの削除を申請するには、サブスクリプションを解除してください。",
  cancel_delete_ok: "OK", // OK
  cancel_delete_request_send: "削除をリクエスト",

  user_apply_delete_account_confirm_tip8: "{date}にサブスクリプションが終了し、あなたのアカウントは永久に削除されます。",
  user_apply_delete_account_confirm_tip4: "下記にメールを送信しました。",
  user_apply_delete_account_confirm_tip5: "アカウントが削除されていることをご確認ください。",
  user_apply_delete_account_confirm_tip6: "削除リクエストを取り消すには、「キャンセル」をクリックしてください。",
  user_apply_delete_data_always: "HSK Mockアカウントおよび関連する個人データの削除をキャンセルしますか？",
  cancel_delete_yes: "はい",
  cancel_delete_no: "いいえ",

  user_cancel_delete_success: "リクエストをキャンセルしました。あなたのHSK Mockアカウントは削除されません。",
  user_cancel_subscribe_again: "解除したサブスクリプションを再開できます。",

  user_apply_delete_account_confirm_tip9: "サブスクリプションの期限：",
  user_apply_delete_account_confirm_tip10: "いつアカウントを削除しますか？",
  user_apply_delete_account_ok_btn_title: "サブスクリプションの終了時に削除",
  user_apply_delete_account_now_btn_title: "今すぐ削除", // Now

  cancel_out_subscription_abnormal: "サブスクリプション情報に異常があります。",

  user_apply_delete_account_confirm_tip3: "あなたのサブスクリプションはAppleにて自動継続で購入されています。継続前にAppleでサブスクリプションを解除してください。",
  user_apply_delete_stripe_tip: "あなたのサブスクリプションはStripeを通して自動的にクレジットカード/デビットカードに請求されます。私たちのWEBサイトにアクセスしてください。",

  user_apply_delete_account_balance: "アカウント残高",
  user_apply_delete_account_balance_tip: "アカウントを削除すると、残高は永久に失われます。",
  user_apply_delete_account_expire: "あなたのアカウントは3日以内に削除されます。",

  my_class_name: "クラス名",
  my_class_search: "クラスを検索",
  my_class_total: "合計",
  my_class_people: "人",
  my_class_ci: "延べ人数",
  my_class_number: "人数",
  my_class_ci_number: "回数",
  my_class_tips: "内側：HSKとYCTの分布比率",
  my_class_tips1: "外側：HSKとYCT各級の分布比率",
  my_class_all_class: "全てのクラス",
  follow_lesson: "コースを見る",
  real_paper: "実戦模擬試験を受ける",
  start_answer: "解答を始める",
  edit_message_date: "日付",
  edit_message_language: "言語",
  edit_message_zh: "中国語",
  edit_message_en: "英語",
  edit_message_title: "タイトル",
  edit_message_content: "本文を入力してください",
  edit_message_show: "開く",
  edit_message_save_success: "保存しました。",
  edit_message_create_success: "追加しました。",
  edit_message_edit1: "編集",
  edit_message_follow_notice: "通知を見る",
  edit_message_textarea_tips: "リンクを貼り付ける場合は、リンクの後にスペースを入力してください。",
  edit_message_notifications: "通知を管理",
  edit_message_Send_time: "送信日時",
  edit_message_edit_notification: "通知を編集",
  edit_message_add: "通知を追加",
  edit_message_from: "開始日時",
  edit_message_to: "終了日時",
  edit_message_new_add: "通知を追加",
  currency: "通貨選択",
  pay_failed: "支払画面が読み込まれませんか？",
  pay_un_finished: "支払が完了できませんか？",
  select_currency_tips: "ご希望に応じて、下のドロップダウンリストから通貨を選択できます。",
  change_currency_tips: "優先的に使用する通貨は、「アカウント情報」のページからいつでも変更できます。",
  my_homework: "自分の課題",
  my_homework_add: "課題を出す",
  my_homework_all_classes: "全てのクラス",
  my_homework_paper: "試験名",
  my_homework_sent_to: "送信",
  my_homework_sent_on: "送信日時",
  my_homework_due_on: "提出期限",
  my_homework_submitted_assignees: "提出人数/送信人数",
  my_homework_class_hint: "クラス名の周りのアイコンは、課題が一部の学生に対してのみ出されたことを意味しています。",
  my_homework_delay_hint: "提出期限後も課題が提出可能であることを示しています。",
  my_homework_add_send_assignment: "課題を送信",
  my_homework_add_new_assignment: "課題を配信",
  my_homework_edit_assignment: "課題を編集",
  my_homework_add_assignment: "課題を追加",
  my_homework_add_assignment_details: "1. 課題の詳細",
  my_homework_add_issue_time: "送信日時",
  my_homework_add_whether_submit: "提出期限後の提出を許可しますか？",
  my_homework_add_note: "備考",
  my_homework_add_assignees: "2. 送信先",
  my_homework_edit_add_assignees: "送信先",
  my_homework_add_group: "クラスを選択",
  my_homework_add_immediate_release: "今すぐ送信",
  my_homework_add_time_release: "予約送信",
  my_homework_add_are: "はい",
  my_homework_add_no: "いいえ",
  my_homework_detail_back: "自分の課題に戻る",
  my_homework_detail_sent_to: "送信先",
  my_homework_detail_leamers_in: "leamers in",
  my_homework_detail_on: "on",
  my_homework_detail_to_complete_by: "完了予定",
  my_homework_detail_add_assignee: "送信先を追加",
  my_homework_detail_assignee: "送信先",
  my_homework_search_placeholder: "検索内容を入力してください",
  my_homework_stu_sent_by: "送信者",
  my_homework_total_topic_count: "計{count}問",
  my_homework_time_full: "{min}分間",
  my_homework_select_date_time: "日時を選択",
  my_homework_delete_assignment_title: "課題を削除",
  my_homework_delete_assignment_tips: "本当に課題を削除しますか？この操作は取り消せません。",
  my_homework_assignment_add_fail: "課題の送信に失敗しました。",
  my_homework_assignment_add_success: "課題を送信しました。",
  my_homework_assignment_edit_success: "課題を編集しました。",
  my_homework_assignment_edit_fail: "課題の編集に失敗しました。",
  my_homework_assignment_delete_fail: "課題の削除に失敗しました。",
  my_homework_assignment_delete_success: "課題を削除しました。",
  my_homework_assignment_due_on: "期限",
  my_homework_assignment_product: "商品名",
  my_homework_assignment_certificate: "証書",
  my_homework_assignment_reset: "リセット",
  my_homework_assignment_reset_title: "セクションをリセットしますか？",
  my_homework_assignment_gifted: "ギフト数量",
  my_homework_assignment_papers: "枚の試験問題",
  my_homework_assignment_send_to: "課題を下記に送信しました：",
  my_homework_assignment_close_tip: "現在の課題は保存されていません。本当に退出しますか？＞",
  pay_callback_tips: "中国大陸にお住まいで、AlipayもしくはWeChatでのお支払いをご希望の場合は、HSK Mockの中国語版サービス（hskmock.cn）をご利用ください。",
  no_available_class: "選択できるクラスがありません。",
  payment_method: "お支払い方法",
  wechat_pay: "支払",
  alipay_payment: "Alipay",
  card_payment: "クレジットカード",
  card_payment_description: "中国国外のカードに限ります。",
  payment_to_wohui: "我会我匯我慧科技（上海）有限公司への支払",
  order_submitted: "注文が正常に送信されました。速やかにお支払いください。",
  order_number: "注文番号：",
  code_expires: "QRコードの期限まで残り<span style=\"color: #fc5a5a;font-size: 16px;font-weight: 500;\">{time}</span>",
  use_weChat: "WeChatアプリでQRコードをスキャンしてお支払いください。",
  code_expired: "このQRコードは期限切れです。",
  amount_payable: "金額：",
  use_code: "引換コードを使用する",


  tests: "試験の記録",
  level_title: "どの級が目標ですか？",
  level_des: '自分に合った級が分からないなら?<br /><b style="color: #000;cursor: pointer;font-weight: 400;" class="clickable">無料のレベルチェックテスト</b>が受けられます',
  level_HSK_text1: "<span style='font-weight: 700'>HSK</span>は「中文水平考試」の略称で、「中国語のレベルテスト」という意味を持っています。",
  level_HSK_text2: "世界で一番受けられている中国語試験です。",
  level_YCT_text1: "<span style='font-weight: 700'>YCT</span>は「Youth Chinese Tests」の略称です。",
  level_YCT_text2: "小中学生のための中国語試験です。",
  level_PRIMARY: '初級',
  level_BEGINNER: "初級",
  level_INTERMEDIATE: "中級",
  level_ADVANCED: "上級",
  level_dialog_title: "レベルテスト",
  level_dialog_content: "無料のレベルチェックテストの所要時間は、約15分間です。テスト結果には、あなたの現在のHSKレベルおよび「聞く」「読む」「書く」「話す」の四技能がどのくらいそのレベルに近いかが表示されます。",
  level_dialog_login: "ログイン / 新規登録",
  level_dialog_start: "レベルチェックテストを始める",
  about_us_first_paragraph: "<b>HSK Mock</b>は、世界で一番受けられている中国語検定・HSKとYCT唯一の公式模擬試験プラットフォームです。<b>漢考国際</b>と<b>Wo Hui Mandarin</b>が共同で提供しています。",
  about_us_second_paragraph: "<b>漢考国際</b> (CTI)は、HSKとYCTの試験実施委員会です。本部を北京に置く有限責任会社で、外国語としての中国語の学習・指導・試験の普及やサポートのための様々なサービスを世界中の個人・法人に向けて提供しています。",
  about_us_third_paragraph: "<b>Wo Hui Mandarin</b> (Wo Hui)は、HSKとYCTの学習・模擬試験サービスを提供する公式オンラインプラットフォームです。本部をシンガポールに置く有限責任会社で、技術を通して学生に学びを届けているほか、教師の皆様が学生ひとりひとりの学習をサポートするためのお力添えをしています。",
  about_us_cti_text: "詳しく知るには：",
  about_us_wohui_text: "より詳しく知りたい場合は、下記にご連絡ください：",
  listening_section: "聞き取り部分",
  reading_section: "読解部分",
  writing_section: "作文部分",
  review_answers: "答案の振り返り",
  characters_long: 'If you don’t yet have an account, set a password between 6 and 20 characters long.',
  complete_profile: "プロフィールを作成しましょう",
  verify_email: "メールアドレス認証",
  link_sent: "ご登録ありがとうございます。下記メールアドレスに送られたリンクをクリックし、メールアドレスの認証を完了させてください：",
  resend_link: "リンクを再送する >",
  restart: "再起動",
  parental_consent: "保護者の同意",
  sent_parental: "ご登録ありがとうございます。お送りしたメールの指示に従い、ご両親もしくは保護者の方の同意を得てください。（分からないばあいは、おうちの方にきいてね）",
  thank_you: "ありがとうございます！",
  or_return: "またはアプリに戻る",
  child_profile: "お子様のプロフィール",
  sign_up_privacy: "<a class=\"link\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{url}\">『利用規約』</a>及び<a class=\"link\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{userUrl}\">『プライバシーポリシー』</a>に同意します。",
  give_consent: "アカウント作成に同意します",
  delete_child_details: "お子様の情報を削除する",
  account_created: "アカウントが作成されました。",
  emailed_know: "<span style='font-weight: 700'>{email}</span>に通知のメールをお送りしました。",
  account_deleted: "アカウントの削除が完了しました。",
  child_know_deleted: "情報が削除済みであることをお子様にお伝えください。",
  request_email: "メールアドレスを除く全ての情報は、ログイン後に更新が可能です。お子様がアカウントを作成することに同意いただくか、詳細情報の削除をご希望の場合は私たちにご連絡ください。",
  preferred_currency: "優先的に使用する通貨",
  parent_guardian: "保護者",
  class_name: "クラス名",
  tofficial_platform: "唯一のHSK公式模擬試験プラットフォーム",
  tofficial_platform_new: "HSK公式の模擬試験プラットフォーム",
  proficiency_tests: "試験の記録",
  proficiency_tests_new: "本物の試験問題・プロの採点・語彙強化・スマート練習を使って、効率的に試験の準備をしよう",
  get_started: "始める",
  get_started_new: "始める",
  start_practicing: "練習を始める",
  get_ready: "HSKに向けて、今すぐ始めよう！",
  real_hsk_exam_content: "本物の試験問題",
  real_hsk_exam_desc: "本物の試験問題を使った効率的な練習で、自信を持って試験を受けましょう。",
  official_level_scoring: "プロの採点",
  official_level_scoring_desc: "HSK公式の基準に基づいて、信頼できる採点結果をお届けします。",
  vocabulary_boost: "語彙強化",
  vocabulary_boost_desc: "無料の単語カードとスマート練習ツールを使って、楽しくボキャブラリーを増やしましょう。",
  get_hsk_ready: "Get HSK-Ready",
  how_it_works: "使い方",
  choose_your_level: "1)級を選ぶ",
  choose_your_level_desc: "HSK1級からHSK9級の間で、自分に合った級を選びましょう。",
  practise_and_learn: "2)練習とテスト",
  practise_and_learn_desc: "まずは無料の単語練習から始めましょう！アカウントをアップグレードすると、公式模擬試験とスマート採点がアンロックされます。",
  track_your_progress: "3)日々の進歩を追跡",
  track_your_progress_desc: "試験のたびにスコアを確認することで、あなたの進歩は一目瞭然。伸ばすべきスキルを知り、効率的に試験の準備を進めましょう。",
  got_questions: "ご質問ですか？私たちがお答えします。",
  faq: "よくある質問",
  faq_desc: "HSKに向けた試験準備とHSK Mockに関するよくある質問を掲載しています。",
  faq_btn: "よくある質問を見る",
  blog: 'ブログ',
  blog_desc: 'ぜひ私たちのブログへ。HSKに向けた試験準備のコツをお伝えします。',
  blog_btn: 'ブログを見る',

  contact: 'お問い合わせ',
  contact_desc: 'よくある質問・ブログで解決しないお悩みはこちらへ。HSK Mockのサポートチームにご連絡ください。',
  contact_btn: '問い合わせる',


  mock_tests: "模擬試験",
  blog_and_faq: "ブログ & よくある質問",
  real_results_from_real_learners: "本物の結果は、本物のフィードバックから",
  support: "サポート",
  choose_your_hsk_level: "HSKの級を選択",
  choose_your_hsk_level_desc: "公式模擬試験とスマートツールを使って、HSK・HSKK口試・YCTに向けた準備を進めましょう。",
  hsk_levels: "HSK",
  hsk_speaking: "HSKK口試",
  yct: "YCT",
  // hsk3.0
  hsk_levels_tri: 'New HSK',

  for_hsk3_condidates: "HSK 3受験生に適用",
  for_hsk4_condidates: "HSK 4受験生に適用",
  for_hsk56_condidates: "HSK 5-6受験生に適用",
  platform_china: "中国大陸の受験生の方に向けた模擬試験サービスもご用意しております。",
  take_confidence: "自身を持ってHSKを受験しよう",
  practice_tests: "試験の記録",
  using_time: "実際に出題された過去問を使用することで、問題の形式や試験の要求を理解し、解答のスピードを上げて万全の状態で試験に臨むことができます。",
  instant_results: "結果がすぐに分かる",
  each_test_question: "一度解いた問題は、一問一問あとから見直すことができます。点数だけでなく、問題ごとの正誤や正しい解答も見ることができるので、ミスの原因や取り組むべきことが明確にわかります。",
  track_progress: "進歩の足跡を記録",
  ready_next_test: "HSK Mockは、あなたが模擬試験を受ける度に日付や時間、技能の向上と成績の変化を自動で記録します。これらの記録に基づいて、試験を受けるベストなタイミングをお知らせします。",
  receive_official_certificates: "模擬試験の公式合格証書を発行",
  certificates_provide_evidence: "模擬試験に合格するごとに、公式の合格証書が発行されます。この証書は、あなたの中国語レベルが一定の水準に達していることを示します。",
  ready_next_level: "Be ready for the next HSK level",
  check_description: "次の級の説明を読んで、目標を明確にしましょう。試験の要求と規則、学ぶべき語彙や試験の内容をチェックすることで、万全の状態で実際の試験に臨みましょう。",
  on_the_move: "モバイル版を使用しますか？",
  on_the_move_new: "HSK Mockのアプリをダウンロードして、",
  download_mobile: "ダウンロードはこちらのボタンから",
  download_mobile_new: "いつでもどこでも、試験の準備をしよう。",
  footer: "HSK Mockは、HSK公式の模擬試験プラットフォームです。本物の試験問題・プロの採点・語彙強化・スマート練習で、効率的な試験準備をサポートします。",
  isp: "Copyright © 2025 HSK Mock",
  start_learning: "今すぐ始めよう！",
  for_institutions: "学校・教育機関向け",
  hsk_beginner_advanced: "<span style='font-weight: 700'>HSK</span>は「中文水平考試」の略称で、「中国語のレベルテスト」という意味を持っています。世界で一番受けられている中国語試験で、初級から上級まで合わせて9つの級があります。",
  more: "もっと見る >",
  more_menu: "詳しく知る",
  ytc_beginner_advanced: "<span style='font-weight: 700'>YCT</span>は「Youth Chinese Tests」の略称で、小中学生のための中国語試験です。初級から中級まで合わせて4つの級があります。",
  coming_end: "2023年末リリース予定",
  candidates_proficiency_speaking: "会話",
  level_oral_tests: "<span style='font-weight: 700'>HSKK(口試)</span>は「中文水平口語考試」の略称で、中国語の会話能力を測る検定試験です。",
  check_test_dates: "試験日程",
  book_test: "受験申込",
  international_platform: "中国版は中国大陸において、国際版はシンガポールにおいて運営されており、それぞれが独立したプラットフォームとなっています。ご自身に合ったプラットフォームをお選びください。",
  mock_platform: "The official mock testing platform",
  home_proficiency_tests: "試験の記録",
  currency_type: "通貨の選択",
  Pick_your_level: "級を選ぶ",
  About_this_level: "級の紹介",
  test_session: "試験",
  Learning_resources: "学習リソース",
  Take_practice_test: "練習テストを受ける",
  Compare_syllabuses: "指標の比較",
  table_shows_syllabuses: "この表では、HSK各級を様々な語学力の指標と比較できます。",
  forrgin_lang: "0547は「外国語としての中国語」の指標です。",
  Second_Language: "0523は「第二言語としての中国語」の指標です。",
  Requirement_entry: "入学要件",
  most_Chinese_universities: "大部分の中国の大学",
  Qing_Hua: "清華大学",
  beijing_university: "北京大学",
  working_towards: "あなたにオススメの級は",
  On: "On",
  Level_test: "レベルテスト",
  Retake_level_test: "レベルチェックテストを受け直す",
  practice_test: "練習テストを受ける",
  Compare_syllabuses_a: "他の指標と比較する",
  Not_sure: "自分のレベルが不明ですか？",
  free_level_test: "レベルチェックテストを受験する",

  Examples: "例題",
  product_code: "商品引換コード",
  enter_paper: "引換コードを入力して、試験を受けましょう。",
  no_code: "引換コードをお持ちではありませんか？HSK Mockのパートナーからご購入ください：",
  to_partner: "パートナーのページへ",
  code_here: "引換コードをここに入力",
  start_assigment: "始める",
  view_assigment: "結果を見る",
  continue_assigment: "次へ",
  choose_method: "お支払い方法の選択",
  choose_new_method: "新しく試験を受けるためのお支払い方法を選択してください。",
  browser_layer: "PCでGoogle Chromeを使用するか、モバイルアプリを使用してください。",
  partner_title1: "パートナーシップのお問い合わせ",
  partner_title2: "ローカルパートナーになりませんか？",
  company_name: "会社名",
  company_website: "会社のWEBサイト",
  teachers_count: "協力するHSK講師の人数",
  learners_count: "協力するHSK受験生の人数",
  add_msg: "よろしければコメントをどうぞ",
  contact_style: "どのようにご連絡すればよろしいですか？",
  send: "送信",
  partner_forms_desc: "HSK Mockのローカルパートナーとして、ご所在の国・地域で受験生・教師・小中高大の学校の主要な連絡先となっていただきます。<br><br>パートナー向けダッシュボードとAPIにより、HSK・YCTの模擬試験問題のオフライン販売、及び貴社の独自サイト・現地通貨でのオンライン販売が可能となります。ローカルパートナーの多くは、業務の拡大と公認を望む、成熟したHSKの試験会場及び予備校によって担われています。<br><br>ローカルパートナーとしての提携をご希望の場合は、まず個人のHSK Mockアカウントでログインし、下記の情報を入力してください。すぐにご連絡を差し上げます。",
  submit_success: "送信成功",
  help_students_for_testing: "学生の試験準備をサポート中ですか？",
  help_students_for_testing_desc: "受験生が次の目標を達成させるためには、教師の皆様のサポートが極めて重要です。HSK Mockは、教師の皆様が受験生ひとりひとりに合ったサポートを提供するためのお手伝いをいたします。",
  become_partner: "ローカルパートナーになる",
  become_partner_desc: "自身の母語を使って試験について問い合わせたり、使い慣れた決済手段を使ったりすることができるローカルパートナーは、受験生にとって大きな存在です。",
  partnership: "パートナーシップのお問い合わせ",
  students_forward: "学生のサポートにも",
  hsk_confidence: "自身を持ってHSKを受験しよう",
  try_it_out: "今すぐ体験",
  walk_through: "試験の流れを知る",
  teachers_page_desc1: "集団指導にも、個別指導にも対応。問題形式に慣れ、学ぶべき語彙や試験の内容をチェックすることで、万全の状態で実際の試験に臨むことができます。",
  assign_practice_papers: "提出期限を設定して試験問題を配布",
  teachers_page_desc2: "模擬試験の問題は、授業の成績評価のための試験問題としても使えます。学生がHSKの様々な問題形式に慣れ、時間内に試験を解き終えるのに役立ちます。",
  get_instant_results: "結果がすぐに分かる",
  teachers_page_desc3: "面倒な採点はもう必要ありません。誰が提出済みかも一目瞭然で、答案ごとの成績も閲覧できます。",
  review_their_answers: "詳しい回答内容を閲覧可能",
  teachers_page_desc4: "クラスごと、技能ごと、問題ごとに結果を分析できます。回答状況を基に、それぞれの学生に合った正確な指導やフィードバックが行えます。",
  track_prog: "進捗を追跡",
  teachers_page_desc5: "試験ごとの成績や問題ごとの解答、さらには能力ごとの成績の変化が詳細に記録されます。これらの記録を参考にすることで、試験を受けるベストなタイミングがわかります。",
  students_next_level: "あなたの学生をさらなる高みへ",
  teachers_page_desc6: "私たちのサービスでは、HSKとYCTの公式教材や、指導に必要な教育ツール・リソースを提供しており、教師の皆様が学生ひとりひとりに合った指導を行うのに役立ちます。",
  teaching_resources: "教育リソース",
  for_teachers: "教師の皆様",
  teachers_desc1: "まず初めに、個人のHSK Mockアカウントでログインしてください。",
  teachers_desc2: "下記に基本情報をご入力ください。学校用に無料トライアルをご設定します。",
  school_name: "学校名",
  school_web: "学校のWEBサイト",
  num_of_hsk_teachers: "HSK講師の人数",
  num_of_hsk_learners: "HSK受験生の人数",
  hsk_submit_reading: "読解",
  pay_tip: "AlipayもしくはWeChatでのお支払いをご希望の場合は、HSK Mockの中国版サービス（hskmock.cn）をご利用ください。",
  use_pc_or_app: "PCを使用するか、モバイルアプリをインストールしてHSK Mockを始めましょう。",
  download_certificate: "証書をダウンロード",
  create_certificate: "証書を生成",
  certificate_is_downloaded: "証書をダウンロードしました。",
  pay_discount_title: "{level}の模擬試験を何回分購入しますか？",
  total: "合計",
  pay: "支払",
  price_desc: "模擬試験の費用のみをお支払いいただきます。一度に複数の模擬試験問題をご購入の場合は、割引が適用されます。",
  the_level: "級",
  discounted_price: "価格",
  price_contact_us: "学校や団体向けのまとめ買いオプションもご用意しております。詳しくはお問い合わせください。",
  get_a_discount: "割引を受ける",
  finished_pay_discount_title: "{level_name}の模擬試験問題の引換コードはこちらです。",
  btn_goto_papers: "Go to the {level_name} papers",
  test_count: "{test_num}回の試験",
  unit_price: "{price}/試験",
  buy_code_tip: "引換コードをメールでお送りしました。{level_name}の試験問題を選択し、引換コードを入力するだけで試験を受けられます。",
  discount_codes_left_tip: "試験終了後、この級の引換コードは<span style=\"color: #62C1A5;font-size: 16px;font-weight: 500;\">残り{count}回分</span>になります。",
  manage_class: "クラスを管理する",
  to_manage_class: "クラス管理システムは新しいタブで開かれます。作業が完了したら、現在のタブに戻ってページを更新してください。",
  code_used: "Used",
  code_can_be_used: "Can be used",
  no_test: "数量",
  history_purchase_quantity: "数量",
  hsk_listen_part_title: "聞き取り：第{count}部分",
  hsk_read_part_title: "読解：第{count}部分",
  hsk_write_part_title: "作文：第{count}部分",
  Description: "紹介",
  Test_format: "試験形式",
  Vocabulary: "語彙",
  other_gender: "秘密/その他",
  intro_msg_first: "この試験は合わせて{num}つの部分で構成されており、順番通りに試験を進める必要があります。",
  intro_msg_second: "既定の時間内にそれぞれの部分の問題を解き終えてください。",
  intro_msg_third: "制限時間前に全ての問題を解き終えた場合、次の部分に進むことができますが、再度前の部分に戻って解答を続けることはできません。",
  dialogue_listening: "第一部分は聞き取り試験です。下のサンプル音声を再生し、必要に応じてデバイスの音声設定を調整してください。",
  dialogue_listening_hskk: 'Play the audio sample below and adjust the audio settings on your device as necessary.',
  dialogue_intro_msg_first: "音楽に合わせて、試験全体の説明が行われます。説明中には、聞き取り部分の問題をプレビューできます。",
  dialogue_intro_msg_first_hskk: 'When the music is playing, a general introduction to the exam will follow.',
  dialogue_intro_msg_second: "実際の試験と同様、音声を一時停止・巻き戻し・早送りすることはできません。",
  dialogue_intro_msg_second_hskk: 'To simulate a real exam, you cannot pause, replay, or fast forward.',
  dialogue_intro_msg_third: "聞き取り部分の音声が全て終了した後、{duration}分間は解答を見直すことができます。",
  dialogue_intro_question: "問題が発生しましたか？",
  dialogue_preload_intro_first: "聞き取り部分の音声をダウンロード中です。",
  dialogue_preload_intro_second: "ダウンロード完了後、音声が自動的に再生されて試験が開始します。",
  dialogue_preload_intro_third: "頑張って！",
  dialogue_preload_title: "試験のリソースをダウンロード中",
  mock_paper_preview: "模擬試験のプレビュー",
  dialogue_mock_paper_intro_title: "試験の説明",
  dialogue_mock_paper_intro_sentence1: "この試験の所要時間は約{minutes}分間です。試験が中断しないよう、十分な時間とバッテリー残量を確保してください。",
  dialogue_mock_paper_intro_sentence2: "この試験は、全てオンラインで行われます。安定したインターネット接続を確保してください。",
  dialogue_mock_paper_intro_sentence3: "デスクトップPC・ノートPCで受験する場合は、最新バージョンのChromeもしくはSafariをご使用ください。",
  dialogue_mock_paper_intro_sentence4: "タブレットPCをご利用の場合は、ブラウザではなくモバイルアプリをご利用ください。",
  dialogue_mock_paper_intro_sentence5: "試験中は、他のタブやアプリを開いたり、言語の切替や他のデバイスの抜き差しを行ったりしないでください。",
  dialogue_mock_paper_intro_button: "下記を読んで理解しました",
  deadline_passed: "提出期限切れ",
  sso_login_signup: "ログイン / 新規登録",
  sso_email_address: "メールアドレス",
  sso_password: "パスワード",
  sso_characters_long: "新規登録の場合は、6~20文字のパスワードを設定してください。",
  sso_forget_pw: "パスワードをお忘れですか？",
  sso_agree_policy: "<a class=\"link\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{url}\">『利用規約』</a>及び<a class=\"link\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"{userUrl}\">『プライバシーポリシー』</a>に同意します。",
  sso_continue: "次へ",
  sso_please_check: "『利用規約』と『プライバシーポリシー』に同意してください。",
  sso_invalid_email_address: "無効なメールアドレスです。",
  sso_invalid_password: "パスワードの形式が間違っています。",
  sso_loading: "ロード中",
  sso_mock_platform: "公式模擬試験プラットフォーム",
  sso_home_proficiency_tests: "世界で一番受けられている中国語検定のための準備をしよう",
  sso_guardian_consent_error: "エラーが発生しました。",
  sso_forget_pw_success: "パスワード再設定メールを送信しました。",
  sso_forget_pw_error: "パスワード再設定メールの送信に失敗しました。",
  sso_log_in_error: "ログインに失敗しました。",
  sso_download_app_mobile: "より良いユーザー体験のため、デスクトップ版でhskmock.comにアクセスするか、アプリをダウンロードしてHSK Mockをご利用ください。",
  sso_no_binding_info_tip: "詳細情報の取得に失敗しました。",
  sso_third_login_tip: "どちらのWEBサイトを開きますか？",
  sso_third_login_wohui: "Wo Hui Mandarinへ",
  sso_third_login_mock: "HSK Mockへ",
  hsk_enter_listening: "聞き取り",
  diologue_mock_paper_quit: "退出",
  vocab_type: "品詞",
  mock_skip_introduction: "説明をスキップしますか？",
  Listening: "聞き取り",
  Reading: "読解",
  Writing: "作文",
  personal_info_display_name_as: "証書に表示される名前",
  code_pratice_text: "この問題で模擬試験を開始",
  code_input_text: "引換コードを入力",
  use_code_limit: 'Each Code can only be used once',
  code_select_text: "または、引換コードを1つ選択してください",
  pay_discounts_desc1: "過去問演習を通してあなたをサポートします",
  pay_discounts_desc2: "[{type}] [{level}] の試験で良い成績が取れますように！",
  pay_discounts_desc3: "2回目の模擬試験を無料プレゼント",
  pay_discounts_desc4: "既に[{type}] [{level}] の本試験にお申し込み済の場合、今回模擬試験を1回分ご購入でもう1回分を無料でプレゼントいたします。",
  pay_discounts_desc5: "模擬試験問題を何回分購入しますか？",
  level_HSKK_text1: "HSK口頭試験(口試/HSKK)は、受験生の中国語会話能力を測る試験です。初級・中級・高級の3つの級に分かれています。",
  level_HSKK_text2: "HSKK口試は、録音形式で行われます。",
  level_HSKK_text3: "HSK3級の受験生はHSKK初級に、HSK4級の受験生はHSKK中級に、HSK5級と6級の受験生はHSKK高級に合格する必要があります。(中国国内で受験する場合。日本国内では別試験として別途申込となります。)",
  test_download_desc: "この級の模擬試験を準備しています。その間に、こちらをダウンロードしてください：",
  speaking: "会話",
  Traduction: '翻訳',
  my_homework_none_homework: "この級の模擬試験は、現在課題用にはサポートされていません。アップデートをお待ちください。",
  my_class_none_test: "この級のオンライン模擬試験は、現在サポートされていません。アップデートをお待ちください。",
  hsk_audio_error: "ネットワーク接続が不安定なため、音声のロードに失敗しました。もう一度お試しください。",
  mock_join_campus_text1: "招待を承諾し、中国語の「教える」「学ぶ」「試験を受ける」コミュニティに参加しますか？",
  mock_join_campus_text2: "コミュニティに参加すると、先生があなたにHSKMock.comで試験問題を出したり、app.wohuimandarin.comで練習問題を出したりすることができるようになります。",
  sso_join_campus_text4: "よりあなた自身に合ったフィードバックを送るため、先生はあなたの解答状況を閲覧できます。",
  join: 'Join',
  spc_welcome: 'Welcome to your free',
  hsk_level_test: "レベルチェックテスト",
  spc_mobile_desc: 'To get started, please switch to a <strong>desk/laptop computer</strong> or else download our <strong>mobile app for phone and tablet.</strong>',
  free_practice_title: "無料練習",
  choose_free_practice: "練習方法を選択",
  word_flashcards: "単語フラッシュカード",
  word_practice: "単語練習",
  analyse_text: "文章分析",
  flashcards_title: "フラッシュカード",
  practice_exercises_title: "練習問題",
  analyse_title: "分析",
  practice_result_title: "練習結果",
  generate_flashcards: "フラッシュカードを生成",
  generate_practice: "練習問題を生成",
  random_select: "自動選択",
  manual_select: "手動選択",
  max_words: "最大{number}語",
  already_choose: "選択済：{total}語",
  free_practice_words_quantifier: 'words',
  free_practice_unchoose_question: "問題のタイプを選択してください",
  free_practice_unchoose_practice: "練習問題のタイプを選択してください",
  none_mark_words_hint: "この級でブックマーク済の単語はありません",
  excceed_max_count: "選択できるのは最大{total}語です。上限に達しました。",
  free_practice_sound: "音声",
  free_practice_question: "問題",
  free_practice_choose_exercise: "練習のタイプを選択",
  free_practice_exercise_select: "選択問題",
  free_practice_exercise_Pairs: "ペア練習",
  free_practice_exercise_TF: "正誤問題",
  launch: "始める",
  free_practice_check_text: "上手くできましたか？",
  free_practice_timer_pause: "タイマー停止中",
  free_practice_timer_pause_desc: "操作が行われない場合、自動でタイマーを停止します",
  free_practice_seconds: "{number}秒",
  resume: "再開",
  flashcard_completed: "フラッシュカード完了",
  practice_completed: "単語練習完了",
  practice_spent_minutes: "所要時間：{duration}分",
  practice_result_summary: "結果の概要",
  practice_result_progress_txt: "正解率",
  practice_wrong: "誤答",
  practice_skip: "スキップ",
  practice_done: "完了",
  analyse_desc_1: "文中で選択した語彙を分析します",
  analyse_desc_2: "中国語をペーストまたは入力（最大{maxCount}文字）",
  analyse_input_placeholder: "中国語を入力",
  free_practice_need_word: "表の中から語彙を選択するか、ランダム生成を選択してください",
  free_practice_exercise_select_title: "正しい解答を選んでください",
  free_practice_exercise_pairs_title: "対応するペアを選んでください",
  free_practice_exercise_meaning_title: "正しい訳は",
  free_practice_exercise_sound_title: "正しい発音は",
  free_practice_exercise_characters_title: "正しい書き方は",
  free_practice_show_correct_answers: "正答を見る",
  free_practice_show_my_answers: "自分の回答を表示",
  free_practice_check: "自分の解答をチェック",
  free_practice_correct: 'Correct',
  free_practice_characters: 'Characters',
  hsk_introduce_objective_questions: "選択問題",
  hsk_introduce_subjective_questions: "記述問題",
  hsk_input_type_here: "ここに入力",
  hsk_translation_part_title: "翻訳：第{count}部分",
  hsk_speaking_part_title: "会話：第{count}部分",
  subjective_reading_placeholder: "上記の文章に基づいて、下記の問題に答えてください…",
  hsk_write_by_artical: "上記の資料に基づいて、文章を書いてください…",
  hsk_translation_by_artical: "上記の資料に基づいて、翻訳してください…",
  hsk_trasnlation_choose_language: "次は翻訳のセクションです。使用する言語を選んでください",
  choose_speaker: "スピーカーを選択",
  choose_microphone: "マイクを選択",
  hsk_is_recording: "録音中",
  dialogue_speaking: "最後は会話のセクションです。お使いのデバイスのスピーカーとマイクが正常に動作していることを確認してください。",
  start_recording: "クリックして録音開始",
  hsk_write_count: "文字数",
  error_access_media: "メディアへのアクセス時にエラーが発生しました。",
  setSinkId_not_supported: "{setSinkId}はお使いのブラウザではサポートされていません。",
  error_switch_device: "デバイスの切替時にエラーが発生しました。",
  translation_section: "翻訳部分",
  speaking_section: "会話部分",
  failed_upload_record: "録音した音声のアップロードに失敗しました。クリックして再度アップロードしてください。",
  hsk_enter_next_segment_write_high: "作文を提出しますか？提出すると作文のセクションが終了し、戻って修正することはできなくなります。",
  hsk_enter_next_segment_translate_tip: "翻訳問題{count}問が未解答です。",
  hsk_enter_next_segment_translate: "翻訳を提出しますか？提出すると翻訳のセクションが終了し、戻って修正することはできなくなります。",
  hsk_enter_next_segment_speaking_tip: "会話問題{count}問が未解答です。",
  Speaking: '会話',
  Translating: '翻訳',
  back_to_home: 'Back to home',
  about_us_desc: '<b>HSK Mock</b> は、HSK・HSKK口試・YCTのための公式オンライン模擬試験プラットフォームです。実際の試験の様子を忠実に再現し、学習者が自信を持って試験に臨めるようサポートしています。',
  who_we_are: '私たちについて',
  who_we_are_desc: '<b>HSK Mock</b>は、漢考国際（Chinese Testing International）と我会中文（Wo Hui Mandarin）が共同運営するサービスです。全世界の中国語学習者に向けて信頼できる模擬試験と学習ツールを提供しています。',
  why_choose_hsk_mock: 'HSK Mockを選ぶ理由',
  about_us_carousel_1: '公式模擬試験データベース',
  about_us_carousel_1_content: 'HSK Mockは、HSK・HSKK口試・YCTの試験形式を忠実に再現した模擬試験を提供しています。',
  about_us_carousel_2: '権威ある採点システム',
  about_us_carousel_2_content: 'HSK Mockは、正式な試験と同じ採点基準を採用しているため、学生の本当のレベルを正確に評価することができます。',
  about_us_carousel_3: '効率的な学習ツール',
  about_us_carousel_3_content: 'HSK Mockは、模擬試験だけでなく、各級に合った語彙練習等の機能も提供しています。HSK Mockを使えば、「聞く」「話す」「読む」「書く」それぞれの技能を全面的に強化できます。',
  about_us_carousel_4: '複数機器での柔軟な学習',
  about_us_carousel_4_content: 'HSK Mockは、PC版とスマホ版をサポートしています。いつでもどこでも、気軽に練習しましょう。',
  about_us_carousel_5: '全世界の学習者に伴走',
  about_us_carousel_5_content: 'HSK Mockは、世界各地の中国語学習者の学習目標達成に向けて伴走しています。',
  institutional_title: '教育団体向け中国語能力評価',
  institutional_desc: 'HSK Mock公式模擬試験プラットフォームは、公式のHSKおよびYCT試験と同一形式のオンライン中国語能力評価を提供し、学校、大学、および各種教育団体が学習者の中国語レベルを評価し、学習進捗を継続的に追跡することを支援します。',
  institutional_btn: '学校/機関向けソリューションを見る',
  institutional_schools_title: '学校と教育団体',
  institutional_schools_desc: '過去のHSK試験問題を通じて、学生がHSKおよびYCT試験を体系的に準備できるよう支援します。',
  institutional_corp_title: '企業と人材資源チーム',
  institutional_corp_desc: '採用、海外派遣、または研修プログラムにおける中国語能力の評価に使用され、企業が従業員の言語能力をより効果的に把握・管理できるよう支援します。',

  real_hsk_exam_content_new: 'HSKの級を選択',
  real_hsk_exam_desc_new: '簡単なレベルテストを完了して、推奨されるHSKレベルを取得しましょう。',
  official_level_scoring_new: '公式HSK模擬試験を受けよう',
  vocabulary_boost_new: '語彙力を強化しよう',
  vocabulary_boost_desc_new: '無料の単語カードとスマート練習ツールを提供しています。',

  confidence_card0_detail_desc: '簡単なレベルテストを完了して、推奨されるHSKレベルを取得しましょう。',
  confidence_card0_detail_btn: '無料レベル診断テスト',
  confidence_choose_level: '級を選ぶ',
  confidence_card1_detail_btn: '続行',
  confidence_choose_method: '練習方法を選択',
}













